import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

type Payload = {
  unifiedId: string
  recurrence: string
}

/**
 * Cancel creation of vehicle exception previously created by createVehicleException
 *
 * @private
 */
export const cancelCreateVehicleException = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/vehicle/cancelCreateException', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const result = await rpc('rpc/vehicle/cancelCreateException', {
      category: 'rpc',
      type: 'rpc/vehicle/cancelCreateException',
      recurrence: payload.recurrence,
      unifiedId: payload.unifiedId,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {createVehicleException}`,
      { tags: ['rpc', 'vehicles'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Create vehicle exception failed`,
      error,
    })
  }
})
